module.exports = __webpack_public_path__ + "static/media/home.7b2b4960.svg";